import {
  PhoneInput as _PhoneInput,
  defaultCountries,
  parseCountry,
} from 'react-international-phone'

export const countries = defaultCountries.filter((country) => {
  const { iso2 } = parseCountry(country)
  return ['us', 'mx', 'gb'].includes(iso2)
})

export function PhoneInput(props: React.ComponentProps<typeof _PhoneInput>) {
  return (
    <_PhoneInput
      className="w-full flex shadow-sm !rounded-md relative"
      inputClassName="w-full !pl-[50px] border-border !rounded-md focus:border-border focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
      inputProps={{
        autoComplete: 'tel-country-code tel-national',
      }}
      countrySelectorStyleProps={{
        buttonClassName: 'absolute !rounded-l-sm',
        buttonContentWrapperClassName:
          'px-3 w-[50px] h-[40px] shrink-0 flex items-center justify-center',
      }}
      countries={countries}
      defaultCountry="us"
      {...props}
    />
  )
}
